require('./bootstrap');


// WEBPACK FOOTER //
// ./resources/assets/js/app.js